module.exports = __webpack_public_path__ + "static/img06-cb2f9d95f4e38a92c29a973dca42c2bf.jpg";